module.exports = __webpack_public_path__ + "assets/static/png/money-grey.3c7e727edde0108bd8de03a3e7f0a303.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/money-grey.png
 ** module id = 509
 ** module chunks = 1
 **/